import { styles as parentStyles } from '../../automaticActionSettings/view/styles';
import { styles as componentStyles } from './view.scss';
import { unsafeCSS } from 'lit';

export const styles = parentStyles.concat(unsafeCSS(`${componentStyles}`));
